const machines = {
  getLoadBalanceSettings() {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/machines/get_lb', defaults);
  },
  setLoadBalanceSettings(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/machines/set_lb', Object.assign(defaults, { data }));
  },
  getUserDBSettings() {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/machines/user_db', defaults);
  },
  getUserDBDetailSettings(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/machines/user_db', Object.assign(defaults, { data }));
  },
  setUserDBSettings(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/machines/user_db', Object.assign(defaults, { data }));
  },

  getOssDBSettings() {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/machines/oss_db', defaults);
  },
  getOssDBDetailSettings(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/machines/oss_db', Object.assign(defaults, { data }));
  },
  setOssDBSettings(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/machines/oss_db', Object.assign(defaults, { data }));
  },
  getCampSettings() {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/machines/camp_setting', defaults);
  },
  getCampDetailSettings(data) {
    const defaults = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/machines/camp_setting', Object.assign(defaults, { data }));
  },
  setCampSettings(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/machines/camp_setting', Object.assign(defaults, { data }));
  },
  getJobCountSettings() {
    const defaults = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };

    return this.request('/1/machines/job_count', defaults);
  },
  setJobCountSettings(data) {
    const defaults = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.getStoragedToken()}`,
      },
    };
    return this.request('/1/machines/job_count', Object.assign(defaults, { data }));
  },
};
export default machines;
